import ImgSpirit from './img-spirit.js'

export default class ScanImgSpirit extends ImgSpirit {
  constructor(...args) {
    super(...args)
    this.offsetY = 0
    this.speedY = 1
  }

  update() {
    // 扫描范围
    const scanRadius = 60
    this.offsetY += this.speedY
    // 扫描效果
    if (this.offsetY > scanRadius || this.offsetY < -scanRadius) {
      this.speedY *= -1
    }
  }

  draw(context, cx, cy) {
    context.save()
    context.beginPath()
    context.arc(cx, cy, 78, 0, Math.PI * 2)
    context.clip()
    context.translate(cx, cy + this.offsetY)
    context.drawImage(this.img, -this.img.width / 2, -this.img.height / 2)
    context.restore()
  }
}
